import {
  transformTeacher,
  transformLanguage,
  transformFeedback,
  transformClassType,
  transformInclude,
  transformOrdering,
} from '@/api/adapters/class-transformer';

/**
 * Transforms parameters from the new classes API (live-instruction) format to the legacy API (webackend) format
 * @param {Object} params - Parameters in new API format
 * @returns {Object} Parameters in legacy API format
 */
const transformDownloadClassesParams = params => {
  const {
    include,
    ordering,
    webackend_class_type: classType,
    is_feedback_submitted: hasFeedback,
    language_code: languageId,
    teacher,
    ...otherParams
  } = params;

  const transformations = [
    transformTeacher(teacher),
    transformLanguage(languageId),
    transformFeedback(hasFeedback),
    transformClassType(classType),
    transformInclude(include),
    transformOrdering(ordering),
  ];

  return {
    ...otherParams,
    ...Object.assign({}, ...transformations.filter(Boolean)),
  };
};

export default transformDownloadClassesParams;
